// src/UIElements/Logs/LogsLogic.js
import { useEffect, useState } from 'react';
import LogsDS from '../../DataServices/LogsDs';
import { useCustomContext } from '../CustomComponents/CustomComponents';

const PAGE_SIZE = 25;

export const LogLogic = () => {
  const logs = new LogsDS();
  const { showAlert, hud, stopHudRotation } = useCustomContext();

  const [logsByPage, setLogsByPage] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMorePages, setHasMorePages] = useState(true);
  const [loadedPages, setLoadedPages] = useState([]);

  const fetchLogsForPage = async (pageNum) => {
    if (loadedPages.includes(pageNum)) return;

    hud('Please Wait...');
    const offset = (pageNum - 1) * PAGE_SIZE;

    try {
      const response = await logs.RM_Activity_Logs_GET({ limit: PAGE_SIZE, offset });
      const data = response.data;
      const body = typeof data.body === 'string' ? JSON.parse(data.body) : data.body;

      if (data.statusCode === 200 && Array.isArray(body.records)) {
        setLogsByPage(prev => ({ ...prev, [pageNum]: body.records }));
        setLoadedPages(prev => [...prev, pageNum]);
        setHasMorePages(body.isMoreRecordsAvailable);
      } else {
        const errorMessage = body?.message || 'Unexpected data format.';
        showAlert(errorMessage, [{ label: 'Ok', onClick: () => { }, color: 'var(--buttonColor)' }]);
      }
    } catch (error) {
      console.error('Error:', error);
      const errorMessage = error.response?.data?.message || error.message || 'An error occurred.';
      showAlert(errorMessage, [{ label: 'Ok', onClick: () => { }, color: 'var(--buttonColor)' }]);
    } finally {
      stopHudRotation();
    }
  };

  useEffect(() => {
    fetchLogsForPage(1);
  }, []);

  const handlePageChange = async (pageNum) => {
    setCurrentPage(pageNum);
    if (!logsByPage[pageNum]) {
      await fetchLogsForPage(pageNum);
    }
  };

  const getCurrentPageLogs = () => logsByPage[currentPage] || [];
  const totalPages = Math.max(...loadedPages, hasMorePages ? currentPage + 1 : currentPage);

  return {
    logs: getCurrentPageLogs(),
    currentPage,
    totalPages,
    handlePageChange,
    PAGE_SIZE
  };
};
